import ReactDOM from 'react-dom/client';
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import reduxStore from './redux/store';
import 'bootstrap/dist/css/bootstrap.min.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-modern-drawer/dist/index.css'

import { PersistGate } from 'redux-persist/integration/react';
import AppRouter from './routesApp';
import 'mapbox-gl/dist/mapbox-gl.css'; 
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';  
import SessionRecorder from './features/recorder/session_recorder';
const { store, persistor } = reduxStore();

const App = () => {
  return (
    <Provider store={store}>
    <PersistGate persistor={persistor}>
    <ToastContainer
          position="bottom-right"
          theme="colored"
          />
    <BrowserRouter>
    <SessionRecorder />
      <AppRouter />
    </BrowserRouter>
    </PersistGate>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />)